module.exports = __webpack_public_path__ + "static/media/heaven.74a0bc0e.jpg";